import { format } from 'date-fns';

const transformDateToBack = (date: Date): string =>
  format(date, "yyyy'-'MM'-'dd' 'HH':'mm':'ss");

export default transformDateToBack;
